/**
 * WordPress dependencies
 */
import { SelectControl, CheckboxControl, BaseControl, RangeControl } from '@wordpress/components';
import { compose } from '@wordpress/compose';
import { withSelect } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';
import { __ } from '@wordpress/i18n';
import { addFilter, applyFilters } from '@wordpress/hooks';

/**
 * Exteranl dependencies.
 */
import Select from 'react-select';

/**
 * Internal dependencies
 */
import AuthorControl from './author-control';
import { has } from 'lodash';

const orderOptions = [
	{
		label: __( 'Decending' ),
		value: 'desc',
	},
	{
		label: __( 'Ascending' ),
		value: 'asc',
	},
];

const orderByOptionsDefault = [
	{
		label: __( 'Date' ),
		value: 'date',
	},
	{
		label: __( 'Title' ),
		value: 'title',
	},
];

const AdvanceQueryControls = ( props ) => {
	const { query, taxonomies, taxonomiesTerms, onChange, excludeFields = [], orderByOptions = [], availablePostTypes = [] } = props;
	const { orderBy, order, numberOfItems, authorIds = [], tax: taxQuery = {} } = query;
	const setQuery = ( val ) => {
		onChange( {
			...query,
			...val,
		} );
	};

	return <>
		{ applyFilters( `gutenify--AdvanceQueryControls--fields`, [], props ) }

		<SelectControl
			label={ __( 'Order' ) }
			value={ order }
			onChange={ ( val ) => {
				setQuery( {
					order: val,
				} );
			} }
			options={ orderOptions }
		/>
		<SelectControl
			label={ __( 'Order by' ) }
			value={ orderBy }
			onChange={ ( val ) => {
				setQuery( {
					orderBy: val,
				} );
			} }
			options={ orderByOptions.length > 0 ? orderByOptions : orderByOptionsDefault }
		/>
		{ taxonomies?.length > 0 && taxonomies.map( ( tax ) => {
			return <BaseControl key={ `tax-$${ tax.slug }` }>
				{ ( taxonomiesTerms[ tax.slug ] && taxonomiesTerms[ tax.slug ]?.length > 0 ) && <>
					<h2 htmlFor={ `tax-term-${ tax.slug }` }>{ tax.name }</h2>
					{ ( taxonomiesTerms[ tax.slug ] && taxonomiesTerms[ tax.slug ]?.length ) && <>{ taxonomiesTerms[ tax.slug ].map( ( term ) => {
						const isChecked = has( taxQuery, `${ tax.slug }` ) && taxQuery[ tax.slug ].includes( term.id );
						return <div key={ `tax-term-${ term.slug }` }>
							<CheckboxControl label={ term.name } checked={ isChecked } onChange={ () => {
								const _taxQuery = taxQuery;
								if ( ! has( taxQuery, `${ tax.slug }` ) ) {
									_taxQuery[ tax.slug ] = [];
								}
								if ( _taxQuery[ tax.slug ].includes( term.id ) ) {
									_taxQuery[ tax.slug ] = _taxQuery[ tax.slug ].filter( function( item ) {
										return item !== term.id;
									} );
								} else {
									_taxQuery[ tax.slug ].push( term.id );
								}
								setQuery( {
									tax: {
										..._taxQuery,

									},
								} );
							} } />
						</div>;
					} ) }</> }
				</> }
			</BaseControl>;
		} ) }

		{ ! excludeFields.includes( 'authors' ) && <AuthorControl value={ authorIds.join( ',' ) } onChange={ ( val ) => {
			let authors = val?.author.split( ',' );
			authors = authors.filter( ( author ) => '' !== author );
			setQuery( {
				authorIds: authors,
			} );
		} } /> }

		<RangeControl
			label={ __( 'Number of items' ) }
			min={ 1 }
			max={ 100 }
			value={ numberOfItems }
			onChange={ ( val ) => {
				setQuery( {
					numberOfItems: val,
				} );
			} } />
	</>;
};

export default compose( [ withSelect( ( select, props ) => {
	let { postTypes = [], query } = props;
	const { postTypes: queryPostTypes = [] } = query;
	postTypes = queryPostTypes.length > 0 ? queryPostTypes : postTypes;

	const { getEntityRecords, getPostTypes, getTaxonomy } = select( coreStore );

	const availablePostTypes = getPostTypes( { per_page: -1 } )?.filter(
		( { viewable } ) => viewable
	);

	const filteredPostTypes = getPostTypes( { per_page: -1 } )?.filter(
		( { viewable, slug } ) =>
			viewable && postTypes.includes( slug )
	);

	let taxonomies = [];
	const taxonomiesTerms = {};
	let _taxonomies = [];

	if ( filteredPostTypes?.length ) {
		filteredPostTypes.forEach( ( pt ) => {
			if ( pt?.taxonomies ) {
				_taxonomies = [ ...pt.taxonomies, ..._taxonomies ];
			}
		} );
	}
	if ( _taxonomies?.length ) {
		_taxonomies.forEach( ( tax ) => {
			taxonomiesTerms[ tax ] = getEntityRecords( 'taxonomy', tax );
			taxonomies = [ ...taxonomies, getTaxonomy( tax ) ];
		} );
	}

	return {
		taxonomies,
		taxonomiesTerms,
		availablePostTypes,
	};
} ) ] )( AdvanceQueryControls );
